// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_receiving_ui_styles" + "." + "a17d5352" + ".chunk.css";
};